import * as React from 'react';
import { tracker } from '@aether/tracking';
import { DisclaimerBanner } from '@aether/tracking/disclaimer-banner';
import { cn } from '@aether/ui/utils';
import { Outlet, useLocation } from 'react-router';

import { useAuth } from '@/utils/auth';

import { AuthController } from '../controllers/AuthController';
import { CountryController } from '../controllers/CountryController';
import { PageLoaderController } from '../controllers/PageLoaderController';

export default function RootLayout() {
  const { user } = useAuth();
  return (
    <div
      className={cn(
        'relative flex min-h-full flex-col',
        user?.impersonatedBy &&
          'after:absolute after:inset-0 after:border-8 after:border-red-500 print:after:border-none'
      )}
    >
      {user?.impersonatedBy && (
        <div className="absolute left-1/2 top-0 z-30 -translate-x-1/2 rounded-b bg-red-500 px-2 text-body font-bold text-white print:hidden">
          On behalf of {user.email}
        </div>
      )}
      <Outlet />
      <PageLoaderController />
      <AuthController />
      <CountryController />
      <DisclaimerBanner />
      <PageViewTracker />
      <svg style={{ width: 0, height: 0, position: 'absolute' }} aria-hidden="true" focusable="false">
        <linearGradient id="dragon-gradient" x2="1" y2="1">
          <stop offset="0%" stop-color="#ff0000" />
          <stop offset="50%" stop-color="#00ff00" />
          <stop offset="100%" stop-color="#0000ff" />
        </linearGradient>
      </svg>
    </div>
  );
}

function PageViewTracker() {
  const location = useLocation();
  React.useEffect(() => {
    tracker.capture('$pageview');
  }, [location]);
  return null;
}
